import Vue from 'vue';

import store from './store';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import i18n from './plugins/vue-i18n';

import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from "vue2-google-maps/dist/components/cluster";
Vue.component('GmapCluster', GmapCluster);

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import Geocoder from '@pderas/vue2-geocoder';
import LoadScript from 'vue-plugin-load-script';

import VueIziToast from 'vue-izitoast';
import 'izitoast/dist/css/iziToast.min.css';

Vue.use(VueIziToast);

import isMobile from './mixins/isMobile'
import toast from './mixins/toast'

Vue.mixin(isMobile)
Vue.mixin(toast)

Vue.use(LoadScript);
Vue.use(PerfectScrollbar);

import VueGeolocation from 'vue-browser-geolocation';
Vue.use(VueGeolocation);

import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import './plugins/vue-loading-overlay';

Vue.config.productionTip = false;
Vue.use(VueGoogleMaps, {
	load: {
		key: process.env.VUE_APP_MAPS_KEYS,
		libraries: 'places,drawing,visualization',
	},
});

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_ANALYTICS,
	router,
	autoTracking: {
		exception: true
	}
})

import VueTagManager from "vue-tag-manager"
Vue.use(VueTagManager, {
    gtmId: 'GTM-P3J44F6'
})

import Vue100vh from 'vue-100vh-vp';
Vue.component('Vue100vh', Vue100vh);

import device from "vue-device-detector"
Vue.use(device)

import Chartkick from 'vue-chartkick'
Chartkick.configure({language: "pt", mapsApiKey: process.env.VUE_APP_MAPS_KEYS})
Vue.use(Chartkick)

import JsonExcel from "vue-json-excel";
Vue.component('downloadExcel', JsonExcel)

import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)

new Vue({
	router,
	store,
	vuetify,
	geocoder: Geocoder,
	i18n,
	render: h => h(App)
}).$mount('#app');